const pathObj = {
  loginUser: '/v2/admin/login',
  getEarnings: '/v2/admin/earnings',
  getLogs: '/v2/admin/logs',
  getUsers: '/v2/admin/user',
  getUsersDownloadReport: '/v2/admin/user/download-report',
  createUser: '/v2/admin/user',
  updateUser: '/v2/admin/user',
  changeUserStatus: '/v2/admin/user/change-status',
  refreshToken: '/v2/user/refresh-token',
  seriesList: '/v2/user/match/series',
  matchList: '/v2/user/match/list',
  refreshAmount: '/v2/admin/refresh-amount',
  userProfile: '/v2/user/profile',
  userProfileUpdate: '/v2/user/profile-update',
  userEditStake: '/v2/user/edit-stake',
  userEditOneClickStake: '/v2/user/edit-one-click-stake',
  activityLogs: '/v2/user/activity-logs',
  transactionLogs: '/v2/user/transaction/logs',
  matchDetail: '/v2/user/match/detail',
  matchScore: '/v2/user/match/score',
  sportsList: '/v2/user/sport/list',
  inPlayCount: '/v2/user/sport/inplay-count',
  betfairPlaceBet: '/v2/user/match/betfaire-place-bet',
  soccerPlaceBet: '/v2/user/match/soccer-place-bet',
  tennisPlaceBet: '/v2/user/match/tennis-place-bet',
  userInPlaySport: '/v2/user/sport',
  bookmakerBet: '/v2/user/match/bookmaker-place-bet',
  betPosition: '/v2/user/match/get-bet-positions',
  betEventsBetPosition: '/v2/user/match/get-events-bet-positions',
  multiEventPlaceBet: '/v2/user/match/multiple-event-place-bet',
  getCurrentBetsExchanges: '/v2/user/match/my-bets',
  cancelUnmatchedBets: '/v2/user/match/clear-unmatched-bet',
  getBookmakerBets: '/v2/user/match/my-bookmaker-bets',
  getFancyBets: '/v2/user/match/my-fancy-bets',
  getSportsBook: '/v2/user/match/my-sport-book-bets',
  fancyBetPlace: '/v2/user/match/fancy-place-bet',
  multiMarket: '/v2/user/sport/multi-market',
  preminumFancyBets: '/v2/user/match/premium-fancy-place-bet',
  addMatchInMultiMarket: '/v2/user/sport/multi-market',
  getPremiumFancy: '/v2/cron/premium-fancy',
  getBetsData: '/v2/user/match/events-bets',
  getHistory: '/v2/user/match/bet-history',
  messageList: '/v2/user/message/list',
  userSubscribe: '/v2/user/subscribe',
  adminSetting: '/v2/user/site-setting/site-setting-list',
  getWalletTransactions: '/v2/admin/wallet-transaction',
  downloadWalletTransactions: '/v2/admin/wallet-transaction/download',
  getTransactions: '/v2/admin/transaction',
  getTransactionsExcel: '/v2/admin/transaction/excel',
  getTransactionTypes: '/v2/configs/transaction-types',
  getTransactionDetails: '/v2/admin/transaction/details',
  statususer: '/v2/admin/user/change-status',
  getsubadmin: '/v2/admin/subadmin/list',
  editSubadmin: '/v2/admin/subadmin/edit',
  addSubadmin: '/v2/admin/subadmin/add',
  deleteSubAdmin: '/v2/admin/subadmin/delete',
  statusSub: '/v2/admin/subadmin/change-status',
  addMerchant: '/v2/admin/merchant',
  editMerchant: '/v2/admin/merchant',
  getMerchantList: '/v2/admin/merchant/list',
  deleteMerchant: '/v2/admin/merchant',
  changeMerchantStatus: '/v2/admin/merchant/status',
  addOperator: '/v2/admin/operator',
  editOperator: '/v2/admin/operator',
  getOperatorList: '/v2/admin/operator/list',
  deleteOperator: '/v2/admin/operator',
  changeOperatorStatus: '/v2/admin/operator/status',
  updateSettings: '/v2/admin/setting',
  updateCurrencySettings: '/v2/admin/currencies/currencySettings',
  updateCurrencyExchange: 'v2/admin/currencies/currencyExchange',
  updateMcrSettings: '/v2/admin/mcr-settings',
  getSettings: '/v2/admin/setting',
  getCurrencySettings: '/v2/admin/currencies/currencySettings',
  getCurrencyExchanges: '/v2/admin/currencies/currencyExchange',
  getMcrSettings: '/v2/admin/mcr-settings',
  changeMerchantVerified: '/v2/admin/merchant/verify',
  getFAQs: '/v2/admin/faqs',
  getContactUs: '/v2/admin/contact-us',
  changeFAQStatus: '/v2/admin/faqs/status',
  getStaticContent: '/v2/admin/static-content',
  forgotPassword: '/v2/admin/forgot-password',
  resetPassword: '/v2/admin/reset-password',
  changePassword: '/v2/admin/change-password',
  editProfile: '/v2/admin/edit-profile',
  getAllOffers: '/v2/admin/offers',
  getUserDetails: '/v2/admin/user/details',
  getDashboardDetails: '/v2/admin/dashboard',
  getReports: '/v2/admin/report',
  getWalletBalanceWindow: 'v2/admin/wallet-transaction/wallet-balance-window',
  downloadReport: '/v2/admin/download-report',
  getAgents: '/v2/admin/merchant/agents',
  getMicroCreditLoanSlabs: '/v2/admin/micro-credit-loan-slabs',
  getMicroCreditLoanRequests: '/v2/admin/loans',
  ChangeStatusMicroCreditLoanRequests: '/v2/admin/loans/change-status',
  subcategoryList: '/v2/admin/subcategory',
  subCategoryStatus: '/v2/admin/subcategory/change-status',
  deleteSubCategory: '/v2/admin/subcategory',
  subcategoryAdd: '/v2/admin/subcategory',
  subcategoryUpdate: '/v2/admin/subcategory',
  categoryList: '/v2/admin/category',
  categoryAllList: '/v2/admin/category/list',
  categoryStatus: '/v2/admin/category/change-status',
  deleteCategory: '/v2/admin/category',
  categoryAdd: '/v2/admin/category',
  categoryUpdate: '/v2/admin/category',
  orders: '/v2/admin/orders',
  changeOfferStatus: '/v2/admin/offers/change-status',
  categoryGet: '/v2/admin/category/list',
  getCategoryList: '/v2/merchant/list',
  userApproval: '/v2/admin/user/user-approval',
  aml: '/v2/admin/amls',
  downloadAml: '/v2/admin/download-amls'
}

export default pathObj
